import React from "react";

import classes from "./CommingSoon.module.css";

const CommingSoon = (props)=>(
    <div className={classes.CommingSoon}>
        COMMING SOON TO PCARI
    </div>
);

export default CommingSoon;